export const dark = {
  brand: {
    primary: "#FFF",
    primaryLight: "#484848",
    primaryText: "#000",
  },
};

export const light = {
  brand: {
    primary: "#000",
    primaryLight: "#F0F0F0",
    primaryText: "#FFF",
  },
};
